import { LineItem } from '../types/types'

export const addToCart = async (cartBody: { items: LineItem[] }) => {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartBody)
  })

  const data = await response.json()

  return data
}

export const dispatchAddToCartEvent = (productName: string) => {
  document.dispatchEvent(
    new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: {
          name: productName
        },
        quantity: 1
      }
    })
  )
}
